import { formatCurrency } from "./formatCurrency";
import { formatWithThousandsSeparator } from "./formatWithThousandsSeparator";

export function formatAmountOrPercentage(value?: number | string | null, amountType?: string): string {
  if (value == null || !amountType) return "";

  return amountType === "amount" ? formatCurrency(value) : `${formatWithThousandsSeparator(value)}%`;
}
